import { Chip, Tooltip } from '@material-ui/core'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import {
  PLACE_INVITATION_ACCEPT_INVITATION,
  PLACE_INVITATION_ACCEPT_REQUEST,
  PLACE_INVITATION_ADDED,
  PLACE_INVITATION_DECLINED,
  PLACE_INVITATION_IGNORED,
  PLACE_INVITATION_INVITED,
  PLACE_INVITATION_PENDING_REQUEST,
  PLACE_INVITATION_PUBLIC_SUBSCRIBE,
  PLACE_INVITATION_REMOVE_SUBSCRIPTION,
  PLACE_INVITATION_UNSUBSCRIBED,
  PLACE_INVITATIONS,
  PLACE_INVITATION_UNVERIFIED,
  PLACE_DECLINED_BY_USER,
} from '../configs/statusConfigs'
import * as R from 'ramda'

const useStyles = makeStyles((theme) => ({
  chipsInvited: {
    backgroundColor: '#ff9a43',
    color: '#ffffff',
  },
  chipsPending: {
    backgroundColor: '#e5e5e5',
    color: '#000000',
  },
  chipsPendingWithShadow: {
    backgroundColor: '#e5e5e5',
    color: '#000000',
    boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.16)',
  },
  chipsSubscribed: {
    backgroundColor: '#4fd975',
    color: '#ffffff',
  },
  chipsRejected: {
    backgroundColor: '#f74872',
    color: '#ffffff',
  },
  chipsAdded: {
    backgroundColor: '#0073b1',
    color: '#ffffff',
  },
  chipsRejectedByAppUser: {
    backgroundColor: '#f74872',
    color: '#ffffff',
  },
  chipsUnsubscribed: {
    backgroundColor: '#e5e5e5',
    color: '#f74872',
  },
  chipsUnverified: {
    backgroundColor: '#e5e5e5',
    color: '#f74872',
  },
  subscriberChips: {
    fontSize: 14,
  },
}))

export default ({ status, isShadow, isShowTooltip = false }) => {
  const { formatMessage } = useIntl()

  const statusClassNames = {
    [PLACE_INVITATION_ADDED]: 'chipsAdded',
    [PLACE_INVITATION_INVITED]: 'chipsInvited',
    [PLACE_INVITATION_PENDING_REQUEST]: 'chipsPending',
    [PLACE_INVITATION_ACCEPT_REQUEST]: 'chipsSubscribed',
    [PLACE_INVITATION_ACCEPT_INVITATION]: 'chipsSubscribed',
    [PLACE_INVITATION_PUBLIC_SUBSCRIBE]: 'chipsSubscribed',
    [PLACE_INVITATION_DECLINED]: 'chipsRejected',
    [PLACE_INVITATION_IGNORED]: 'chipsRejectedByAppUser',
    [PLACE_INVITATION_REMOVE_SUBSCRIPTION]: 'chipsUnsubscribed',
    [PLACE_INVITATION_UNSUBSCRIBED]: 'chipsUnsubscribed',
    [PLACE_INVITATION_UNVERIFIED]: 'chipsUnverified',
    [PLACE_DECLINED_BY_USER]: 'chipsRejectedByAppUser',
  }

  const styleClass = useStyles()
  let statusStyle = styleClass[statusClassNames[status || 0]]
  if (isShadow && PLACE_INVITATION_PENDING_REQUEST === status) {
    statusStyle = styleClass.chipsPendingWithShadow
  }
  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(
      isShowTooltip &&
        R.includes(status, [
          PLACE_INVITATION_UNVERIFIED,
          PLACE_INVITATION_UNSUBSCRIBED,
        ]),
    )
  }

  return (
    <Tooltip
      arrow
      title={
        status === PLACE_INVITATION_UNVERIFIED
          ? formatMessage({ id: 'crm.unverified.message.text' })
          : formatMessage({ id: 'crm.cannot.send.message.text' })
      }
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
    >
      <Chip
        label={formatMessage({ id: PLACE_INVITATIONS[status || 0] })}
        className={clsx(
          statusStyle,
          styleClass.subscriberChips,
          isShadow && styleClass.shadow,
        )}
        size="small"
      />
    </Tooltip>
  )
}
